import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    marginBottom: `${theme.spacing(4)} !important`,
  },
  paper: {
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: theme.palette.divider,
  },
}));
